import * as THREE from 'three';
import p5 from "p5";
import { QTree } from './drawer/QTree';
import { QTreeDrawer } from './drawer/QTreeDrawer';
import { Params } from '../data/Params';
import { Drawers } from './drawer/Drawers';
import { p5MainBase } from './p5MainBase';
import { BitmapData } from './image/BitmapData';


export class p5Main extends p5MainBase{


    public _width       :number = 512;
    public _height      :number = 512;
    private _p5         :p5;
    private _dom        :HTMLElement;
    public _drawers    :Drawers;
    private _bg         :number=0;
    private _callback   :()=>void;

    constructor(){
        super();
    }

    init(callback:()=>void){

        this._callback=callback;

        new p5((p: p5)=>{
            /** 初期化処理 */
            p.setup = ()=>{
                this.setUp();                
            }
            /** フレームごとの描画処理 */
            p.draw = ()=> {
                this.draw();
            }

            this._p5 = p;
        });
        
    }


    setUp(){

        this._drawers = new Drawers();
        this._drawers.init(()=>{
            this.setUp2();
        });
        
    }

    setUp2(){

        //console.log("setup2")

        this._drawers.show(this._p5)

        let r = this._p5.createCanvas(
            512,
            512
        );
        r.id('p5canvas');
        this._p5.frameRate(30);
        this._p5.noSmooth();
        
        //console.log(r.elt);
        this.canvasElement = r.elt;//scopeがよくわからない
        this.isInit=true;
    
        super.setDebug(r.elt);

        this._bg = 0;
        this._callback();

        Params.gui.add(this,"reset").name("RESET_p5")

    }

    reset(){
        this._drawers?.reset();
    }

    draw(){

        this._p5.background(
            this._bg,
            this._bg,
            this._bg
        );

        this._p5.noStroke();
        
        let nn = 10;
        this._drawers?.update();

     
    }

    
    

}

